import styled from 'styled-components'

export const InputHint = styled.p`
  margin-top: 8px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: #202020;
  opacity: 0.7;
`

export const InputField = styled.input`
  width: 100%;
  height: ${(p) => {
    return p.height
  }};
  border: ${(props) => {
    return props.error ? '1px solid #E11900' : '1px solid rgba(32, 32, 32, 0.2)'
  }};
  border-radius: 4px;
  font-size: 14px;
  line-height: 16px;
  padding: ${(props) => {
    return props.error ? '16px 44px 16px 16px' : '16px'
  }};
  outline: none;
  color: ${(p) => {
    if (p.readOnly) return '#202020'
    return p.disabled ? 'rgba(32, 32, 32, 0.5)' : '#202020'
  }};
  -webkit-text-fill-color: ${(p) => {
    if (p.readOnly || !p.disabled) return '#202020'
    return null
  }};
  opacity: ${(p) => {
    return p.readOnly ? 1 : undefined
  }};
  background-color: ${(p) => {
    return p.readOnly ? 'rgba(250, 250, 250, 1)' : 'transparent'
  }};
  cursor: ${(p) => {
    return p.readOnly ? 'default' : 'text'
  }};
  line-height: ${(p) => {
    return p.readOnly ? '20px' : '16px'
  }};
  background: ${(p) => (p.disabled ? 'rgba(32, 32, 32, 0.02)' : 'rgba(255, 255, 255, 1)')};
  margin-bottom: 0;
  font-weight: 400;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  font-family: Inter;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    border: 1px solid rgba(32, 32, 32, 0.2);
    box-shadow: ${(p) => {
      return p.readOnly ? '0 1px 2px rgba(32, 32, 32, 0.05)' : '0 2px 8px -2px rgba(32, 32, 32, 0.1)'
    }};
  }

  &:focus {
    border: ${(p) => {
      return p.readOnly ? '1px solid rgba(32, 32, 32, 0.2)' : '1px solid #0aa1f4'
    }};
    box-shadow: ${(p) => {
      return p.readOnly
        ? '0 1px 2px rgba(32, 32, 32, 0.05)'
        : '0 1px 2px rgba(32, 32, 32, 0.05), 0 0 0 4px rgba(10, 161, 244, 0.1)'
    }};
    transition: box-shadow 0.1s ease-in-out;
  }

  ::placeholder {
    color: ${(p) => {
      return p.readOnly ? 'rgba(32, 32, 32, 0.7)' : 'rgba(32, 32, 32)'
    }};
  }
`

export const Label = styled.label`
  font-weight: 500;
  margin-bottom: ${(p) => {
    return p.marginBottomLabel ? p.marginBottomLabel : '16px'
  }};
  line-height: 24px;
  color: #202020;
  display: flex;
  align-items: center;
  justify-content: space-between;

  section {
    color: #202020;
  }

  div {
    cursor: pointer;
  }

  svg {
    margin: 0 8px;
  }

  > span {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: rgba(32, 32, 32, 0.5);
  }

`

export const Error = styled.div`
  color: #e11900;
  margin-top: ${(p) => {
    return p.errorMarginTop
  }};
  line-height: 20px;
`

export const TrailingIconsContainer = styled.div`
  position: absolute;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TrailingIcon = styled.div`
  margin-right: 15px;
`

export const InputContainer = styled.div`
  margin-bottom: ${(p) => {
    return p.marginBottomInput ? p.marginBottomInput : '32px'
  }};
  font-size: 14px;
  width: 100%;
`
